import { LimitInclude } from "./Limit";
export var PricingInclude = {
    features: true,
    limits: { include: LimitInclude },
};
//# sourceMappingURL=Pricing.js.map